import { Box, Typography } from '@mui/material';
import { SEOSegmentationPageType } from '@/__generated__/globalTypes';
import { usePageAttributes } from './contexts/PageAttributesContext';

const HeaderText = () => {
  const { segmentNamePluralLowerCase, city, state, pageType } = usePageAttributes();

  // Example: "Infant Daycares"
  const firstWordUpperCase =
    segmentNamePluralLowerCase.charAt(0).toUpperCase() + segmentNamePluralLowerCase.slice(1);
  const headlineText =
    pageType === SEOSegmentationPageType.NATIONAL
      ? `${firstWordUpperCase} near me`
      : `${firstWordUpperCase} in ${city}, ${state}`;

  return (
    <Box my={{ xs: 0, sm: 6 }} mb={{ xs: 3 }} mt={{ xs: 4 }}>
      <Typography variant="h2" align="center">
        {headlineText}
      </Typography>
    </Box>
  );
};

export default HeaderText;
